import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TabBox from './TabBox';
import ItemMediaForm from './ItemMediaForm';
import AddItem from '../molecules/AddItem';
import Download from '../molecules/Download';
import Empty from '../atoms/Empty';
import Button from '../atoms/Button';
import { downloadFile } from '../../lib/apis/file';
import styles from '../../styles/components/organisms/ItemMedia.module.scss';

interface ItemMediaProps {
  venueID?: string;
  serviceProviderID?: string;
  data: any;
  access?: boolean;
  apply: (id: string) => void;
  setLayer: (el: any) => void;
}

const ItemMedia = (props: ItemMediaProps) => {
  const { t } = useTranslation(['common', 'venue', 'service']);
  const [tab, setTab] = useState('');
  const [loading, setLoading] = useState(false);
  const { data, access, venueID, serviceProviderID, setLayer } = props;
  const itemType = !!venueID ? 'venue' : 'service';

  const classes = clsx(styles.itemMedia);

  // Tabs by data
  // const currMediaKeys = data?.map((el: any) => el.category) || [];
  const currMediaKeys = data
    ?.map((el: any) => el.category)
    .reduce(
      (acc: any, curr: any) => [...acc.filter((el: any) => el !== curr), curr],
      []
    );

  const currMediaTabs = currMediaKeys
    .map((key: string) => ({
      id: key,
      label: t(`${itemType}:media:${key}`),
    }))
    .filter((tab: any) =>
      (data || []).some((el: any) => el.category === tab.id)
    );

  // Data by tab
  const files = (data || []).filter((el: any) => el.category === tab);

  const download = (href: string) => {
    setLoading(true);
    downloadFile(href)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const changeTab = (id: string) => {
    const currData = data || [];
    const newTabId = currData.some((el: any) => el.category === id)
      ? id
      : currData[currData.length - 1]?.category || '';
    if (newTabId !== tab) {
      setTab(newTabId);
    }
  };

  useEffect(() => {
    if (!!data && !!data.length && !tab) {
      const tab = data[data.length - 1].category;
      setTab(tab);
    }
  }, [data, tab]);

  return (
    <Row className={classes}>
      <Col xs={8}>
        <TabBox
          onChange={changeTab}
          title={t(`${itemType}:media:headline`)}
          tabs={currMediaTabs}
          className={loading ? styles.loading : undefined}
        >
          {!!access && (
            <AddItem
              restricted={false}
              label={t(`${itemType}:media:add`)}
              href="/promote-your-business"
              onClick={() =>
                setLayer(
                  <ItemMediaForm
                    venueID={venueID}
                    serviceProviderID={serviceProviderID}
                    prefill={{ type: tab }}
                    onSubmit={() => setLayer(null)}
                    onCancel={() => setLayer(null)}
                  />
                )
              }
            />
          )}
          {!!files.length ? (
            <>
              {files.map((file: any, i: number) => {
                const {
                  type,
                  size,
                  title,
                  url,
                  category,
                  name,
                  description,
                  href,
                } = file;
                return (
                  <Download
                    key={i}
                    name={title || name}
                    description={description}
                    type={type}
                    size={size}
                    icon={category === 'maps' ? 'map' : ''}
                    url={url}
                    href={href}
                  >
                    {!!access && (
                      <>
                        <br />
                        <Button
                          tiny
                          dark
                          icon={'edit'}
                          label={t(`common:cta-edit`)}
                          onClick={(e) => {
                            e.stopPropagation();
                            setLayer(
                              <ItemMediaForm
                                venueID={venueID}
                                serviceProviderID={serviceProviderID}
                                prefill={file}
                                onSubmit={() => setLayer(null)}
                                onCancel={() => setLayer(null)}
                              />
                            );
                          }}
                        />
                      </>
                    )}
                  </Download>
                );
              })}
            </>
          ) : (
            <Empty label={t(`${itemType}:media:empty`)} />
          )}
        </TabBox>
        <br />
        <br />
        <br />
      </Col>
    </Row>
  );
};

export default ItemMedia;
